"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitiseRowObjectForExcel = exports.sanitiseTextForExcel = void 0;
function sanitiseTextForExcel(input) {
    if (typeof input !== 'string')
        return input;
    for (let character of ['=', '+', '-', '@', '\n', '\t']) {
        if (input.startsWith(character)) {
            const inputWithEscapedFirstCharacter = input.replace(character, `'${character}`);
            if (input.includes("'")) {
                const inputWithEscapedFirstCharacterAndDoubleQuotes = inputWithEscapedFirstCharacter.replace(/\"/g, '""');
                return `"${inputWithEscapedFirstCharacterAndDoubleQuotes}"`;
            }
            return inputWithEscapedFirstCharacter;
        }
    }
    return input;
}
exports.sanitiseTextForExcel = sanitiseTextForExcel;
function sanitiseRowObjectForExcel(row) {
    return Object.keys(row).reduce((acc, lineKey) => ({
        ...acc,
        [lineKey]: sanitiseTextForExcel(row[lineKey])
    }), {});
}
exports.sanitiseRowObjectForExcel = sanitiseRowObjectForExcel;
